import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  standalone: false
})
export class ButtonComponent {

  @Input() text?: string;
  @Input() type: 'submit' | 'button' = 'button';
  @Input() style: 'filled' | 'outlined' | 'only-text' = 'filled';
  @Input() size: 'small' | 'middle' | 'large' = 'middle';
  @Input() color: 'primary' | 'secondary' | 'error' = 'primary';
  @Input() border: 'round' | 'angular' = 'round';
  @Input() leftIcon?: string;
  @Input() loading: boolean = false;
  @Input() hidden: boolean = false;
  @Input() disabled: boolean = false;
  @Output() clickEvent: EventEmitter<any> = new EventEmitter();

  constructor() {}

  handleClick() {
    this.clickEvent.emit();
  }
}
